import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Recos from 'components/productdetail/Recos';
import { shouldRecosUpdate } from 'helpers/RecoUtils';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';

import { subRecos } from 'styles/components/productdetail/recosDetail.scss';

export class RecosDetail1 extends Component {

  // We don't want this component to re-render when it's either loading, or recommendations haven't changed
  shouldComponentUpdate(nextProps) {
    return shouldRecosUpdate(this.props, nextProps);
  }

  render() {
    const { similarProductRecos = {}, onRecoClicked, numberOfAskQuestions, numberOfReviews, heartsData } = this.props;
    // If we have recommendations, render the component
    const { janus = {}, lastReceivedRecoKey } = similarProductRecos;
    const janusData = janus[lastReceivedRecoKey] || {};
    const janusRecos = janusData['detail-1'];
    if (janusRecos) {
      let { recos } = janusRecos;
      const { title } = janusRecos;
      if (recos && numberOfAskQuestions <= 0 && numberOfReviews <= 0) {
        recos = recos.slice(0, 3);
      }
      return (
        <div className={subRecos}>
          <Recos
            id="alsoBought"
            isVertical={true}
            recoType="crossRecos"
            recos={recos}
            title={title}
            onRecoClicked={onRecoClicked}
            heartsData={heartsData} />
        </div>
      );
    }
    return null;
  }
}

RecosDetail1.propTypes = {
  styleId: PropTypes.string.isRequired,
  params: PropTypes.object.isRequired,
  similarProductRecos: PropTypes.object.isRequired,
  numberOfAskQuestions: PropTypes.number,
  numberOfReviews: PropTypes.number
};

RecosDetail1.defaultProps = {
  numberOfAskQuestions: 0,
  numberOfReviews: 0
};

export default withErrorBoundary('RecosDetail1', RecosDetail1);
